import { RouteObject } from "react-router-dom";
import { GraphQL } from "@rpi/openapi-api";
import { withHandle } from "../../utils/route.util";
import { path as createPath } from "./CustomerProductCreateView";
import { CustomerProductView, ProductInfoV2 } from "./CustomerProductView";
import { ProductCreateNavigator } from "./ProductCreateNavigator";
import { CustomerProductEditView } from "./CustomerProductEditView";
import { EditProductV2 } from "./CustomerProductEditViewV2";
import { featureFlags } from "../../featureFlags";

// Editing customer products is for product owners; SuperAdmins are excluded.
const editRequiredRole = [GraphQL.DashboardUserRole.User, GraphQL.DashboardUserRole.CustomerAdmin];

export const productCreateRoute: RouteObject = {
  path: createPath,
  element: <ProductCreateNavigator />,
  ...withHandle("customer-product-create"),
};

export const productDetailsRoute: RouteObject = featureFlags.newProductDetails
  ? {
      path: ":id",
      element: <ProductInfoV2 />,
      ...withHandle("customer-product-detail"),
    }
  : {
      path: ":id",
      element: <CustomerProductView />,
      ...withHandle("customer-product-detail"),
    };

export const productEditRoute: RouteObject = featureFlags.newProductDetails
  ? {
      path: ":id/edit",
      element: <EditProductV2 />,
      ...withHandle("customer-product-edit", { requiredRole: editRequiredRole }),
    }
  : {
      path: ":id/edit",
      element: <CustomerProductEditView />,
      ...withHandle("customer-product-edit", { requiredRole: editRequiredRole }),
    };
